import React, { ReactElement } from 'react';
import { Button } from 'b2b-components/theme/components/Button';
import { useTranslate } from 'b2b-apps/core/i18n/hooks';
import { Props } from './AddItemsToExistingCartContent.types';
import './AddItemsToExistingCartContent.scss';

export const AddItemsToExistingCartContent = ({
  onClearAndAdd,
  onAdd,
  onClose,
}: Props): ReactElement => {
  const t = useTranslate();

  return (
    <div className='AddItemsToExistingCartContent-Root'>
      <h5>
        {t('Add items from kanban form to existing basket?')}
      </h5>

      <div className='Modal-ContentAlert'>
        <div>{t('Basket already contains other products')}</div>
      </div>

      <div className='AddItemsToExistingCartContent-Buttons'>
        <Button
          size={Button.config.size.small}
          onClick={onAdd}
        >
          {t('Add items')}
        </Button>

        <Button
          size={Button.config.size.small}
          styleType={Button.config.styleType.secondary}
          onClick={onClearAndAdd}
        >
          {t('Clear basket and add items')}
        </Button>

        <Button
          size={Button.config.size.small}
          styleType={Button.config.styleType.light}
          onClick={onClose}
        >
          {t('Cancel')}
        </Button>
      </div>
    </div>
  );
};
